import React from 'react'
import AnonymousView from '../anonymous-view'

const AnonymousViewFr = () => {
    return <AnonymousView languageCode="fr" />
}

export default AnonymousViewFr
